export default __webpack_public_path__ + "static/media/earthling_7.5e34ba53.png";